export const calendarDefaults = {
  lang: 'ja',
  format: 'yyyy/MM/dd',
  dayHeaderFormat: 'Y年m月',
  pane: 1,
  clearButton: false,
  disableSwitchMonthView: true,
}

export const calendarLangFunc = (lang) => {
  let ret = {
    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ],
  }
  if (lang === 'ja') {
    ret = {
      daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
      months: [
        '1', '2', '3', '4', '5', '6',
        '7', '8', '9', '10', '11', '12'
      ],
    }
  }

  return ret
}
